export default "__VITE_ASSET__3765b1ce__"